<template>
  <div>
    <promised :promise="promise" v-if="!hasError">
      <template #pending>
        <patient-card-widget-skeleton></patient-card-widget-skeleton>
      </template>
      <template #default>
        <p class="chart-widget__description"> {{ chartTitle }}</p>
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </template>
      <template v-slot:rejected="error">
        <p>Error: {{ error.message }}</p>
      </template>
    </promised>
    <div v-else class="widget-permission-error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import WidgetMixin from "@/components/mixins/WidgetMixin";
import PatientCardWidgetSkeleton from "@/components/skeletons/PatientCardWidgetSkeleton";
import {EventBus} from "@/lib/EventBus";
import GenericWidgetGuard from "@/components/permissions/GenericWidgetGuard";
import ChartMixin, {injectFakeDataAction} from "@/components/mixins/ChartMixin";

export default {
  name: "ActigraphyChartWidget",
  components: {PatientCardWidgetSkeleton},
  mixins: [WidgetMixin, ChartMixin],
  widget: {
    serviceMethod: 'getCharts',
    title: null,
    guard: GenericWidgetGuard
  },
  afterDataLoaded({ data: [{title, data, subtitle}]}) {
    injectFakeDataAction.call(this)
    if (this.widgetModel.settings.isCentralMonitoring) {
      this.emitSubtitle(title)
    } else {
      this.emitTitle(title)
      this.emitSubtitle(subtitle)
    }
    this.emitTitleTooltip(data.chart_description)

    this.chartOptions.series = data.series

    if (data.start_time && data.interval_length) {
      this.chartOptions.plotOptions.series =  {
        pointStart: this.$helpers.getDate({ date: data.start_time }).valueOf(),
        pointInterval: data.interval_length * 1000
      }
    }

    this.applyStandardSettings(data)
  },
  methods: {
    reflow() {
      if (this.$refs.chart) {
        this.$refs.chart.chart.reflow()
      }
    }
  },
  mounted() {
    EventBus.$on('reflow-chart', this.reflow)
  },
  beforeUnmount() {
    EventBus.$off('reflow-chart', this.reflow)
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: (9 / 16 * 100) + '%',
          type: 'line',
          zoomType: 'x',
          panning: true,
          panKey: 'shift'
        },
        yAxis: {
          visible: false,
          endOnTick: false,
        },
        xAxis: {
          type: 'datetime'
        },
        legend: {
          enabled: false,
          symbolHeight: 0.00001
        },
        title: '',
        credits: {
          enabled: false
        },
        series: [],
        tooltip: {
          formatter() {
            const text = this.point.tooltiptext
            return text ? this.point.tooltiptext.replace("\n", "<br/>") : false
          }
        },
        plotOptions: {
          series: {},
          line: {
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 1,
              lineColor: 'rgba(23, 149, 241, 0.5)',
              lineWidth: 11,
            }
          }
        }
      }
    }
  }
}
</script>
